import React, { useEffect, useState } from 'react';
import { Header, Icon, Loader, Message, Segment, Select, Table } from 'semantic-ui-react';
import { getTopSearches } from '../../services/Metrics';
import { MONTH_OPTIONS, getCurrentPeriod } from './metricsHelpers';

function MetricsSearchSection() {
  const [period, setPeriod] = useState(getCurrentPeriod());
  const [state, setState] = useState({ data: [], loading: true, error: false });

  useEffect(() => {
    setState((s) => ({ ...s, loading: true, error: false }));
    getTopSearches(period)
      .then((res) => {
        if (res.status === 200 && res.data.success) {
          setState({ data: res.data.result ?? [], loading: false, error: false });
        } else {
          setState({ data: [], loading: false, error: true });
        }
      })
      .catch(() => setState({ data: [], loading: false, error: true }));
  }, [period]);

  return (
    <Segment className="transparent-table">
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '1em',
        }}
      >
        <Header as="h3" color="teal" style={{ margin: 0 }}>
          <Icon name="search" />
          <Header.Content>Top recherches</Header.Content>
        </Header>
        <Select
          options={MONTH_OPTIONS}
          value={period}
          onChange={(_, { value }) => setPeriod(value)}
          compact
        />
      </div>
      {state.loading && <Loader active inline="centered" />}
      {state.error && <Message error content="Impossible de charger les top recherches." />}
      {!state.loading && state.data.length === 0 && !state.error && (
        <Message info content="Aucune recherche enregistrée pour cette période." />
      )}
      {!state.loading && state.data.length > 0 && (
        <Table basic="very" unstackable compact>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell textAlign="center">#</Table.HeaderCell>
              <Table.HeaderCell>Recherche</Table.HeaderCell>
              <Table.HeaderCell textAlign="right">Occurrences</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {state.data.slice(0, 10).map((item, index) => (
              <Table.Row key={item.query ?? item.term ?? index}>
                <Table.Cell textAlign="center">{index + 1}</Table.Cell>
                <Table.Cell>{item.query ?? item.term ?? item.value ?? '—'}</Table.Cell>
                <Table.Cell textAlign="right">{item.count ?? item.total ?? '—'}</Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
      )}
    </Segment>
  );
}

export default MetricsSearchSection;
